import cn from 'clsx'
import Select from 'react-select'

import { Button } from 'shared-components'

import s from './ProjectCategories.module.sass'

function ProjectCategories({ projectCategories, selectedProjectCategory, handleProjectCategoryClick }: any) {
    if (projectCategories?.length === 0 || !projectCategories) {
        return null
    }

    const selectOptions = [
        { label: 'All Projects', value: '' },
        ...projectCategories.map((projectCategory: any) => ({
            label: projectCategory.name,
            value: projectCategory.slug,
        })),
    ]

    return (
        <div className={s.ProjectCategories}>
            <div className={s.ProjectCategoriesSelect}>
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={selectOptions}
                    placeholder="All Projects"
                    isSearchable={false}
                    value={selectOptions.find((option) => option.value === selectedProjectCategory) || null}
                    onChange={(option) => {
                        const value = option?.value || ''
                        handleProjectCategoryClick(value)
                    }}
                />
            </div>
            <div
                className={cn(s.ProjectCategory, selectedProjectCategory === '' && s.Active)}
                onClick={() => handleProjectCategoryClick('')}
            >
                <Button
                    title="All"
                    handleClick={() => handleProjectCategoryClick('')}
                    small
                    noArrow
                    inverted={selectedProjectCategory === ''}
                />
            </div>
            {projectCategories?.map((projectCategory: any, index: number) => {
                const { name, slug } = projectCategory

                return (
                    <div className={cn(s.ProjectCategory, selectedProjectCategory === slug && s.Active)} key={index}>
                        <Button
                            title={name}
                            handleClick={() => handleProjectCategoryClick(slug)}
                            small
                            noArrow
                            inverted={selectedProjectCategory === slug}
                        />
                    </div>
                )
            })}
        </div>
    )
}

export default ProjectCategories
